/* ARÈTE Body Oil — PDP behaviour: gallery, bundle picker, AJAX cart drawer (2 + 1 FREE as real bottles), sticky bar, reviews. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Offer settings ----------
     These must match Shopify admin:
     - Automatic discount "Buy 2, Get 1 Free": Buy X get Y, customer buys 2 × the oil, gets 1 × the oil FREE, no limit per order.
     - Shipping (UK): £4.95 under £50, FREE tracked delivery from £50 (price after discounts). */
  var CFG = {
    freeShipFrom: 5000,   // pence
    shipping: 495,        // pence
    reserveMinutes: 10,
    giftsNote: '30ml Travel Body Oil + Mystery Gift',
    freeLabel: 'FREE with Buy 2, Get 1 Free'
  };

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents, currency) {
    var value = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency || 'GBP',
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return '£' + value.toFixed(2);
    }
  }

  function postJSON(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---------- 2 + 1 maths: every 2 paid bottles bring 1 free bottle ---------- */
  function totalFor(paid) { return paid + Math.floor(paid / 2); }
  function paidFor(total) { return total - Math.floor(total / 3); }

  function ids() {
    var d = $('[data-ib-drawer]');
    return {
      single: d ? parseInt(d.getAttribute('data-single-id'), 10) : 0,
      bundle: d ? parseInt(d.getAttribute('data-bundle-id'), 10) : 0
    };
  }

  function qtyOf(cart, variantId) {
    var q = 0;
    cart.items.forEach(function (i) { if (i.variant_id === variantId) q += i.quantity; });
    return q;
  }

  // Old "Buy 2 Get 1 Free" variant in a basket? Swap it for 3 real bottles.
  function migrateBundle(cart) {
    var v = ids();
    if (!v.single || !v.bundle) return Promise.resolve(cart);
    var b = qtyOf(cart, v.bundle);
    if (!b) return Promise.resolve(cart);
    var updates = {};
    updates[v.bundle] = 0;
    updates[v.single] = totalFor(paidFor(qtyOf(cart, v.single)) + 2 * b);
    return postJSON('cart/update.js', { updates: updates });
  }

  // Set the number of oil bottles in the basket (adds via cart/add so add-to-cart tracking fires).
  function setOil(total) {
    var v = ids();
    return getCart().then(function (cart) {
      var cur = qtyOf(cart, v.single);
      if (total > cur) {
        return postJSON('cart/add.js', { items: [{ id: v.single, quantity: total - cur }] }).then(getCart);
      }
      var updates = {};
      updates[v.single] = Math.max(0, total);
      return postJSON('cart/update.js', { updates: updates });
    });
  }

  function oilState(cart, singleId) {
    var s = { qty: 0, orig: 0, paid: 0, unit: 0, image: '', title: '', discTitle: '' };
    cart.items.forEach(function (i) {
      if (i.variant_id !== singleId) return;
      s.qty += i.quantity;
      s.orig += i.original_line_price;
      s.paid += i.final_line_price;
      s.unit = i.original_price || i.price;
      s.image = s.image || i.image || '';
      s.title = i.product_title;
      (i.line_level_discount_allocations || []).forEach(function (a) {
        if (!s.discTitle && a.discount_application && a.discount_application.title) s.discTitle = a.discount_application.title;
      });
    });
    s.free = s.unit ? Math.round((s.orig - s.paid) / s.unit) : 0;
    s.paidQty = s.qty - s.free;
    return s;
  }

  /* ---------- Menu ---------- */
  function initMenu() {
    var menu = $('[data-ib-menu]');
    if (!menu) return;
    function set(open) {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('ib-lock', open);
    }
    $$('[data-ib-menu-open]').forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
    $$('[data-ib-menu-close]', menu).forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* ---------- Announcement bar ---------- */
  function initAnnounce() {
    var msgs = $$('.ib-announce__msg');
    if (msgs.length < 2) return;
    var i = 0;
    window.setInterval(function () {
      var cur = msgs[i];
      i = (i + 1) % msgs.length;
      cur.classList.add('is-leaving');
      cur.classList.remove('is-active');
      cur.setAttribute('aria-hidden', 'true');
      msgs[i].classList.remove('is-leaving');
      msgs[i].classList.add('is-active');
      msgs[i].removeAttribute('aria-hidden');
      window.setTimeout(function () { cur.classList.remove('is-leaving'); }, 600);
    }, 4200);
  }

  /* ---------- Header: scrolled state, jump bar, scrollspy ---------- */
  function initHeader() {
    var header = $('[data-ib-header]');
    if (!header) return;
    var jump = $('[data-ib-jump]', header);
    var buy = document.getElementById('ib-product-form') || document.getElementById('ib-buy');
    var links = jump ? $$('.ib-jump__link', jump) : [];
    var targets = [];
    links.forEach(function (a) {
      var id = (a.getAttribute('href') || '').replace('#', '');
      var el = id && document.getElementById(id);
      if (!el) { a.hidden = true; return; }
      targets.push({ a: a, el: el });
    });
    var active = null;
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      header.classList.toggle('is-scrolled', y > 8);
      if (jump && buy) {
        var past = buy.getBoundingClientRect().bottom < 0;
        header.classList.toggle('has-jump', past && targets.length > 0);
      }
      if (!targets.length) return;
      var line = 140, current = null;
      targets.forEach(function (t) { if (t.el.getBoundingClientRect().top <= line) current = t; });
      if (current !== active) {
        if (active) active.a.classList.remove('is-active');
        active = current;
        if (active) {
          active.a.classList.add('is-active');
          var track = active.a.parentNode;
          track.scrollTo({ left: active.a.offsetLeft - 16, behavior: 'smooth' });
        }
      }
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { onScroll(); ticking = false; });
    }, { passive: true });
    onScroll();
  }

  /* ---------- Clinicians' Choice card ---------- */
  function initClinic() {
    var cc = $('[data-ib-cc]');
    if (!cc) return;
    var key = 'ib-cc-hidden';
    try { if (window.sessionStorage.getItem(key)) cc.hidden = true; } catch (e) {}
    var btn = $('[data-ib-cc-close]', cc);
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      cc.classList.add('is-hidden');
      window.setTimeout(function () { cc.hidden = true; }, 300);
      try { window.sessionStorage.setItem(key, '1'); } catch (err) {}
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    var track = $('[data-ib-gallery-track]');
    if (!track) return;
    var thumbs = $$('[data-ib-thumb]');
    var slides = $$('[data-ib-slide]', track);
    var current = 0;

    function go(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      var active = thumbs[i];
      if (active && active.parentNode) {
        var p = active.parentNode;
        p.scrollTo({ left: active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-ib-thumb'), 10)); });
    });
    var prev = $('[data-ib-gallery-prev]');
    var next = $('[data-ib-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    var count = $('[data-ib-count]');
    // Arrows and the counter are hidden on load, appear on scroll, touch or hover, and fade out again after 2.5 s.
    var main = track.parentNode, idleTimer;
    function wake() {
      main.classList.remove('is-idle');
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(function () { main.classList.add('is-idle'); }, 2500);
    }
    ['pointerdown', 'pointermove', 'focusin'].forEach(function (ev) { main.addEventListener(ev, wake, { passive: true }); });
    track.addEventListener('scroll', wake, { passive: true });
    // Start hidden: arrows and counter only appear once someone touches, hovers or swipes the gallery.
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) { current = i; }
        mark(current);
        if (count) count.textContent = current + 1;
        ticking = false;
      });
    }, { passive: true });

    track.setAttribute('tabindex', '0');
    track.setAttribute('aria-label', 'Product images, use the arrow keys to browse');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
  }

  /* ---------- Card carousels (results, videos, oils, before/after) ---------- */
  function initCarousels() {
    $$('[data-ib-carousel]').forEach(function (wrap) {
      var track = $('[data-ib-track]', wrap);
      if (!track) return;
      var prev = $('[data-ib-prev]', wrap);
      var next = $('[data-ib-next]', wrap);
      var bar = $('[data-ib-bar]', wrap);

      function cards() {
        return Array.prototype.filter.call(track.children, function (c) { return c.offsetWidth > 0; });
      }
      function step() {
        var list = cards();
        if (list.length < 2) return track.clientWidth;
        var one = list[1].offsetLeft - list[0].offsetLeft;
        var perView = Math.max(1, Math.floor((track.clientWidth + 1) / one));
        return one * perView;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var scrollable = max > 4;
        wrap.classList.toggle('is-static', !scrollable);
        if (!scrollable) return;
        var x = track.scrollLeft;
        if (prev) prev.disabled = x <= 4;
        if (next) next.disabled = x >= max - 4;
        if (bar) {
          var w = Math.max(12, Math.min(100, (track.clientWidth / track.scrollWidth) * 100));
          bar.style.width = w + '%';
          bar.style.transform = 'translateX(' + ((x / max) * (100 - w) / w * 100) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      else window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Selling-out timer (UK time) ---------- */
  function initUrgency() {
    var el = $('[data-ib-urgency]');
    if (!el) return;
    var out = $('[data-ib-timer]', el);
    var box = out && out.parentNode;
    var mode = el.getAttribute('data-mode');
    if (!out || mode === 'none') return;

    var fmt;
    try {
      fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
    } catch (e) { return; }

    // The UK wall-clock time as a UTC timestamp, so date maths works in London time.
    function londonNow() {
      var p = {};
      fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function clock(ms) {
      var t = Math.max(0, Math.floor(ms / 1000));
      var d = Math.floor(t / 86400); t -= d * 86400;
      var h = Math.floor(t / 3600); t -= h * 3600;
      var m = Math.floor(t / 60); var sec = t - m * 60;
      return (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    }
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    function target(now) {
      if (mode === 'end') {
        var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/.exec(el.getAttribute('data-end') || '');
        if (!m) return null;
        return { at: Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59), m[4] ? 0 : 59), label: el.getAttribute('data-label-end'), day: '' };
      }
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
      var today = new Date(now);
      for (var i = 0; i < 8; i++) {
        var d = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate() + i, cutoff, 0, 0));
        var wd = d.getUTCDay();
        if (wd === 0 || wd === 6 || d.getTime() <= now) continue;
        var word = i === 0 ? 'today' : (i === 1 ? 'tomorrow' : 'on ' + days[wd]);
        return { at: d.getTime(), label: el.getAttribute('data-label-dispatch'), day: word };
      }
      return null;
    }

    function tick() {
      var now = londonNow();
      var t = target(now);
      if (!t || t.at <= now) { box.hidden = true; return; }
      var parts = (t.label || '[time]').split('[time]');
      out.innerHTML = esc(parts[0]).replace('[day]', esc(t.day)) + '<strong>' + clock(t.at - now) + '</strong>' + esc(parts.slice(1).join('')).replace('[day]', esc(t.day));
      box.hidden = false;
    }
    tick();
    window.setInterval(tick, 1000);
  }

  /* ---------- Bundle picker + add to basket ---------- */
  function initBuyBox() {
    var form = document.getElementById('ib-product-form');
    if (!form) return;
    var input = $('[data-ib-variant-input]', form);
    var offers = $$('[data-ib-offer]', form);
    var atcBtn = $('[data-ib-atc]', form);
    var atcPrice = $('[data-ib-atc-price]', form);
    var errorEl = $('[data-ib-form-error]', form);
    var stickyPrice = $('[data-ib-sticky-price]');
    var stickyOffer = $('[data-ib-sticky-offer]');

    function select(offer) {
      if (!offer) return;
      var radio = $('input[type="radio"]', offer);
      if (radio && radio.disabled) return;
      offers.forEach(function (o) {
        var on = o === offer;
        o.classList.toggle('is-selected', on);
        var r = $('input[type="radio"]', o);
        if (r) r.checked = on;
      });
      input.value = offer.getAttribute('data-variant-id');
      if (atcPrice) atcPrice.textContent = offer.getAttribute('data-price');
      if (stickyPrice) stickyPrice.textContent = offer.getAttribute('data-price');
      if (stickyOffer) stickyOffer.textContent = offer.getAttribute('data-offer-title');
    }

    offers.forEach(function (o) {
      o.addEventListener('click', function (e) { e.preventDefault(); select(o); });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(o); }
      });
      o.setAttribute('tabindex', '0');
    });

    $$('[data-ib-choose-offer]').forEach(function (link) {
      link.addEventListener('click', function () {
        var n = parseInt(link.getAttribute('data-ib-choose-offer'), 10) - 1;
        if (offers[n]) select(offers[n]);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      atcBtn.disabled = true;
      var v = ids();
      var chosen = parseInt(input.value, 10);
      var job;
      if (v.single && v.bundle && (chosen === v.bundle || chosen === v.single)) {
        // Start from an empty basket so a second click never doubles the order,
        // then add real bottles: 2 + 1 = 3 × the single bottle (the discount makes the 3rd free).
        job = postJSON('cart/clear.js', {}).then(function () {
          return postJSON('cart/add.js', { items: [{ id: v.single, quantity: chosen === v.bundle ? 3 : 1 }] });
        });
      } else {
        job = postJSON('cart/clear.js', {}).then(function () {
          return postJSON('cart/add.js', { items: [{ id: chosen, quantity: 1 }] });
        });
      }
      job
        .then(function () { return Drawer.refresh(); })
        .then(function () { Drawer.open(); })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
            errorEl.hidden = false;
          }
        })
        .then(function () { atcBtn.disabled = false; });
    });

    /* Sticky bar */
    var sticky = $('[data-ib-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var below = entry.boundingClientRect.top < 0;
          var show = !entry.isIntersecting && below;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          var btn = $('[data-ib-sticky-btn]', sticky);
          if (btn) btn.tabIndex = show ? 0 : -1;
        });
      });
      io.observe(atcBtn);
      var sBtn = $('[data-ib-sticky-btn]', sticky);
      if (sBtn) sBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atcBtn.click();
      });
    }
  }

  /* ---------- Cart drawer ---------- */
  var GREEN = '#2f6b3a';
  var DRAWER_CSS =
    /* reservation: slim and calm */
    '.ib-oil .ib-reserve{flex-shrink:0;display:flex;align-items:center;justify-content:center;gap:6px;background:var(--ib-note);border-bottom:1px solid var(--ib-line);color:var(--ib-brown);font-size:12.5px;padding:8px 16px}' +
    '.ib-oil .ib-reserve svg{width:14px;height:14px;color:var(--ib-gold-d)}' +
    '.ib-oil .ib-reserve strong{font-variant-numeric:tabular-nums;color:var(--ib-gold-d)}' +
    /* progress: text + bar only, gone once unlocked */
    '.ib-oil .ib-progress{padding:12px 20px 14px;gap:8px}' +
    '.ib-oil .ib-progress__steps{display:none}' +
    '.ib-oil .ib-progress.is-done{display:none}' +
    /* paid line */
    '.ib-oil .ib-line{border-bottom:0;padding-bottom:0}' +
    '.ib-oil .ib-line__img{width:76px;height:76px}' +
    '.ib-oil .ib-line__sub{font-size:12.5px;color:var(--ib-muted)}' +
    '.ib-oil [data-ib-lines]{display:flex;flex-direction:column;gap:14px}' +
    /* free bottle line */
    '.ib-oil .ib-line__img{position:relative}' +
    '.ib-oil .ib-line__badge{position:absolute;left:5px;top:5px;background:' + GREEN + ';color:#fff;font-size:9.5px;font-weight:800;letter-spacing:.08em;padding:3px 7px;border-radius:999px}' +
    '.ib-oil .ib-line__tag{font-size:12.5px;font-weight:700;color:' + GREEN + '}' +
    '.ib-oil .ib-line__free{font-size:16px;font-weight:800;letter-spacing:.04em;color:' + GREEN + '}' +
    '.ib-oil .ib-line__compare{font-size:13px}' +
    /* included-free box */
    '.ib-oil .ib-incl{background:var(--ib-gold-l);border-radius:12px;padding:12px 14px;display:flex;flex-direction:column;gap:8px}' +
    '.ib-oil .ib-incl__head{font-size:11px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:' + GREEN + '}' +
    '.ib-oil .ib-incl__row{display:flex;align-items:center;gap:10px;font-size:13.5px;font-weight:600;color:var(--ib-ink)}' +
    '.ib-oil .ib-incl__row img{width:30px;height:30px;border-radius:6px;object-fit:cover;background:#fff}' +
    '.ib-oil .ib-incl__row .ib-incl__dot{width:30px;height:30px;border-radius:6px;background:#fff;display:flex;align-items:center;justify-content:center;color:var(--ib-gold-d)}' +
    '.ib-oil .ib-incl__dot svg{width:16px;height:16px}' +
    '.ib-oil .ib-incl__name{flex:1}' +
    '.ib-oil .ib-incl__was{font-size:12px;font-weight:400;color:var(--ib-muted);text-decoration:line-through;margin-right:6px}' +
    '.ib-oil .ib-incl__free{font-size:12.5px;font-weight:800;letter-spacing:.04em;color:' + GREEN + '}' +
    '.ib-oil [data-ib-gifts]{display:none!important}' +
    /* compact upsell */
    '.ib-oil .ib-upsell{padding:16px 14px 14px;gap:10px}' +
    '.ib-oil .ib-upsell__img,.ib-oil .ib-upsell__lines{display:none}' +
    '.ib-oil .ib-upsell__title{font-size:21px}' +
    '.ib-oil .ib-upsell__text{font-size:13px}' +
    /* footer */
    '.ib-oil .ib-drawer__foot{gap:7px;padding-top:14px}' +
    '.ib-oil .ib-sum--disc,.ib-oil .ib-sum--save{font-weight:700;color:' + GREEN + '}' +
    '.ib-oil [data-ib-save-row]{display:none!important}' +
    '.ib-oil .ib-sum--total{border-top:1px solid var(--ib-line);margin-top:4px;padding-top:10px}' +
    '.ib-oil .ib-sum--total small{display:block;font-family:var(--ib-sans);font-size:12px;font-weight:700;color:' + GREEN + ';margin-top:2px}' +
    '.ib-oil .ib-drawer__foot .ib-small,.ib-oil .ib-drawer__foot .ib-btn__sub{display:none}' +
    '.ib-oil .ib-drawer__foot [data-ib-checkout]{min-height:54px;margin-top:4px}' +
    '.ib-oil [data-ib-checkout] .ib-lock{display:inline-flex;align-items:center;gap:8px}' +
    '.ib-oil [data-ib-checkout] .ib-lock svg{width:15px;height:15px}' +
    '.ib-oil .ib-pay{align-items:center;gap:5px}' +
    '.ib-oil .ib-pay{display:flex;justify-content:center;flex-wrap:wrap}' +
    '.ib-oil .ib-pay svg{height:22px;width:auto;display:block}' +
    '.ib-oil .ib-assure{display:flex;align-items:center;justify-content:center;gap:6px;flex-wrap:wrap;font-size:11.5px;color:var(--ib-muted)}' +
    '.ib-oil .ib-assure b{color:var(--ib-gold);letter-spacing:1px;font-weight:400}';

  var ICON = {
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    bottle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 3h6v3H9zM8 6h8v15H8z"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10h16v10H4zM3 7h18v3H3zM12 7v13M12 7c-2-4-6-3-5 0M12 7c2-4 6-3 5 0"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>'
  };

  var Drawer = {
    el: null,
    state: null,
    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ib-lock');
      var close = $('[data-ib-cart-close].ib-iconbtn', this.el);
      if (close) close.focus();
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ib-lock');
    },
    refresh: function () {
      var self = this;
      return getCart().then(migrateBundle).then(function (cart) { self.render(cart); return cart; });
    },
    lineHtml: function (item, currency) {
      var img = item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')) + '" alt="" loading="lazy">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return '<div class="ib-line" data-key="' + esc(item.key) + '">' +
        '<div class="ib-line__img">' + img + '</div>' +
        '<div class="ib-line__info">' +
          '<div class="ib-line__title">' + esc(item.product_title) + '</div>' +
          (variant ? '<div class="ib-line__variant">' + esc(variant) + '</div>' : '') +
          '<div class="ib-line__row">' +
            '<div class="ib-qty">' +
              '<button type="button" data-ib-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-ib-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div><span class="ib-line__price">' + money(item.final_line_price, currency) + '</span></div>' +
          '</div>' +
        '</div>' +
      '</div>';
    },
    render: function (cart) {
      var el = this.el;
      $$('[data-ib-cart-count]').forEach(function (c) {
        c.textContent = cart.item_count;
        c.hidden = cart.item_count === 0;
      });
      if (!el) return;
      var cur = cart.currency;
      var singleId = parseInt(el.getAttribute('data-single-id'), 10);
      var s = oilState(cart, singleId);
      this.state = s;
      var bundle = s.free > 0;
      var empty = cart.item_count === 0;
      var delivery = cart.total_price >= CFG.freeShipFrom ? 0 : CFG.shipping;
      var img = s.image ? '<img src="' + esc(s.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')) + '" alt="" loading="lazy">' : '';

      $('[data-ib-drawer-count]', el).textContent = cart.item_count;

      /* Progress bar */
      var text;
      if (empty) text = el.getAttribute('data-progress-empty');
      else if (bundle) text = el.getAttribute('data-progress-bundle');
      else if (s.qty === 2) text = 'Add bottle 3, it’s FREE, and unlock 3 gifts';
      else text = 'Add 1 more bottle and get the 3rd FREE + 3 gifts';
      $('[data-ib-progress-text]', el).textContent = text;
      var prog = $('.ib-progress', el);
      if (prog) prog.classList.toggle('is-done', bundle);
      $('[data-ib-progress-fill]', el).style.width = bundle ? '100%' : (s.qty >= 2 ? '67%' : (s.qty ? '34%' : '0%'));
      $$('[data-ib-milestone]', el).forEach(function (m, idx) {
        m.classList.toggle('is-done', idx === 0 ? (!empty && delivery === 0) : bundle);
      });

      /* Gifts from the drawer settings (name + value) */
      var gifts = $$('[data-ib-gifts] .ib-freegift', el).map(function (g) {
        var lbl = $('.ib-freegift__label', g), val = $('.ib-freegift__value', g);
        var n = parseFloat(((val && val.textContent) || '').replace(/[^0-9.]/g, ''));
        return { name: lbl ? lbl.textContent.trim() : '', value: isNaN(n) ? 0 : Math.round(n * 100), text: val ? val.textContent.trim() : '' };
      });

      /* Lines: paid bottles, then everything included free */
      var html = '';
      if (s.qty) {
        html += '<div class="ib-line" data-ib-oil>' +
          '<div class="ib-line__img">' + img + '</div>' +
          '<div class="ib-line__info">' +
            '<div class="ib-line__title">' + esc(s.title) + '</div>' +
            '<div class="ib-line__sub">' + s.paidQty + ' × 100ml' + (bundle ? ' · Buy 2, Get 1 Free' : '') + '</div>' +
            '<div class="ib-line__row">' +
              '<div class="ib-qty">' +
                '<button type="button" data-ib-paid="' + (s.paidQty - 1) + '" aria-label="Remove a bottle">−</button>' +
                '<span>' + s.paidQty + '</span>' +
                '<button type="button" data-ib-paid="' + (s.paidQty + 1) + '" aria-label="Add a bottle">+</button>' +
              '</div>' +
              '<div><span class="ib-line__price">' + money(s.paid, cur) + '</span></div>' +
            '</div>' +
          '</div>' +
        '</div>';
        if (bundle) {
          html += '<div class="ib-line ib-line--free">' +
            '<div class="ib-line__img">' + img + '<span class="ib-line__badge">FREE</span></div>' +
            '<div class="ib-line__info">' +
              '<div class="ib-line__title">' + esc(s.title) + '</div>' +
              '<div class="ib-line__sub">' + (s.free > 1 ? s.free + ' × 100ml · your free bottles' : 'Bottle 3 · 100ml') + '</div>' +
              '<div class="ib-line__row"><span></span>' +
                '<div><span class="ib-line__compare">' + money(s.unit * s.free, cur) + '</span><span class="ib-line__free">FREE</span></div>' +
              '</div>' +
            '</div>' +
          '</div>';
          var row = function (icon, name, was) {
            return '<div class="ib-incl__row">' + icon + '<span class="ib-incl__name">' + esc(name) + '</span>' +
              (was ? '<span class="ib-incl__was">' + esc(was) + '</span>' : '') + '<span class="ib-incl__free">FREE</span></div>';
          };
          html += '<div class="ib-incl"><div class="ib-incl__head">Your free gifts</div>' +
            gifts.map(function (g) {
              var icon = /deliver/i.test(g.name) ? ICON.truck : (/travel|ml/i.test(g.name) ? ICON.bottle : ICON.gift);
              return row('<span class="ib-incl__dot">' + icon + '</span>', g.name, g.text);
            }).join('') +
          '</div>';
        }
      }
      var self = this;
      cart.items.forEach(function (item) { if (item.variant_id !== singleId) html += self.lineHtml(item, cur); });
      $('[data-ib-lines]', el).innerHTML = html;

      /* Gifts + upsell */
      $('[data-ib-gifts]', el).hidden = !bundle;
      var upsell = $('[data-ib-upsell]', el);
      upsell.hidden = !(s.qty && s.qty < 3 && !bundle);
      if (!upsell.hidden) {
        var btn = $('[data-ib-upgrade]', upsell);
        if (s.qty === 2) {
          $('.ib-upsell__title', upsell).innerHTML = 'Your 3rd bottle is <em>FREE</em>';
          $('.ib-upsell__text', upsell).textContent = 'Add it for £0, plus a travel oil, a mystery gift and free delivery.';
          btn.innerHTML = '<span>Add my FREE bottle</span>';
        } else {
          $('.ib-upsell__title', upsell).innerHTML = 'Add 1, get the 3rd <em>FREE</em>';
          $('.ib-upsell__text', upsell).textContent = 'Plus a 30ml travel oil, a mystery gift and free tracked delivery.';
          btn.innerHTML = '<span>Upgrade to 2 + 1 · +' + money(s.unit, cur) + '</span>';
        }
      }
      $('[data-ib-empty]', el).hidden = !empty;
      $('[data-ib-foot]', el).hidden = empty;

      /* Totals, with delivery included */
      var giftValue = 0;
      gifts.forEach(function (g) { giftValue += g.value; });
      var discount = cart.original_total_price - cart.total_price;
      $('[data-ib-subtotal]', el).textContent = money(cart.original_total_price, cur);
      var discRow = $('[data-ib-disc-row]', el);
      if (discRow) {
        discRow.hidden = discount <= 0;
        $('[data-ib-disc-label]', el).textContent = s.discTitle || 'Buy 2, Get 1 Free';
        $('[data-ib-disc]', el).textContent = '−' + money(discount, cur);
      }
      $('[data-ib-delivery]', el).textContent = delivery ? money(delivery, cur) : 'FREE';
      var saveRow = $('[data-ib-save-row]', el);
      saveRow.hidden = !bundle;
      if (bundle) saveRow.lastElementChild.textContent = money(discount + giftValue, cur);
      $('[data-ib-total]', el).textContent = money(cart.total_price + delivery, cur);
      var totalLbl = $('.ib-sum--total span', el);
      if (totalLbl) totalLbl.innerHTML = 'Total' + (bundle ? '<small>You save ' + money(discount + giftValue, cur) + '</small>' : '');
      var coLabel = $('[data-ib-checkout] .ib-lock span', el);
      if (coLabel) coLabel.textContent = 'Secure checkout · ' + money(cart.total_price + delivery, cur);

      /* Gifts note on the order, so you know what to pack */
      var note = bundle ? CFG.giftsNote : '';
      var attrs = cart.attributes || {};
      if ((attrs['Free gifts'] || '') !== note) {
        postJSON('cart/update.js', { attributes: { 'Free gifts': note } }).catch(function () {});
      }

      this.reserve(!empty);
    },
    reserve: function (active) {
      var bar = $('[data-ib-reserve]', this.el);
      if (!bar) return;
      bar.hidden = !active;
      if (!active) return;
      var key = 'ib-reserve-until', until = 0, now = Date.now();
      try { until = parseInt(window.sessionStorage.getItem(key), 10) || 0; } catch (e) {}
      if (!until) {
        until = now + CFG.reserveMinutes * 60000;
        try { window.sessionStorage.setItem(key, String(until)); } catch (e) {}
      }
      this.until = until;
      this.tick();
    },
    tick: function () {
      var bar = this.el && $('[data-ib-reserve]', this.el);
      if (!bar || bar.hidden) return;
      var left = Math.max(0, Math.floor((this.until - Date.now()) / 1000));
      if (!left) {
        bar.innerHTML = ICON.clock + '<span>High demand: complete your order to secure today’s offer</span>';
        return;
      }
      var m = Math.floor(left / 60), sec = left % 60;
      bar.innerHTML = ICON.clock + '<span>Your order is reserved for <strong>' + (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec + '</strong></span>';
    },
    // Real payment logos: copied from the Shopify payment icons already in the footer (or any store page).
    payIcons: function () {
      var box = $('.ib-pay', this.el);
      if (!box) return;
      var order = ['visa', 'master', 'american_express', 'paypal', 'apple_pay', 'google_pay', 'shopify_pay', 'klarna'];
      function fill(svgs) {
        var byType = {};
        svgs.forEach(function (svg) {
          var t = (svg.getAttribute('aria-labelledby') || '').replace(/^pi-/, '');
          if (t && !byType[t]) byType[t] = svg;
        });
        var picked = order.filter(function (t) { return byType[t]; });
        if (!picked.length) return;
        box.innerHTML = '';
        picked.forEach(function (t) {
          var svg = byType[t].cloneNode(true);
          var title = svg.querySelector('title');
          svg.setAttribute('aria-label', title ? title.textContent : t);
          svg.removeAttribute('aria-labelledby');
          if (title) title.removeAttribute('id');
          box.appendChild(svg);
        });
      }
      var local = $$('svg[aria-labelledby^="pi-"]').filter(function (svg) { return !box.contains(svg); });
      if (local.length) { fill(local); return; }
      fetch(root, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        fill(Array.prototype.slice.call(doc.querySelectorAll('svg[aria-labelledby^="pi-"]')));
      }).catch(function () {});
    },
    busy: function (btn, job) {
      var self = this;
      if (btn) btn.disabled = true;
      return job.then(function (cart) { self.render(cart); })
        .catch(function () { return self.refresh(); })
        .then(function () { if (btn) btn.disabled = false; });
    },
    init: function () {
      var self = this;
      this.el = $('[data-ib-drawer]');
      $$('[data-ib-cart-open]').forEach(function (b) {
        b.addEventListener('click', function () { self.refresh().then(function () { self.open(); }); });
      });
      if (!this.el) return;

      // Styles + extra rows (reservation timer, discount line).
      var style = document.createElement('style');
      style.textContent = DRAWER_CSS;
      document.head.appendChild(style);
      var head = $('.ib-drawer__head', this.el);
      if (head && !$('[data-ib-reserve]', this.el)) {
        var bar = document.createElement('div');
        bar.className = 'ib-reserve';
        bar.setAttribute('data-ib-reserve', '');
        bar.hidden = true;
        head.parentNode.insertBefore(bar, head.nextSibling);
      }
      var sub = $('[data-ib-subtotal]', this.el);
      if (sub && !$('[data-ib-disc-row]', this.el)) {
        var row = document.createElement('div');
        row.className = 'ib-sum ib-sum--disc';
        row.setAttribute('data-ib-disc-row', '');
        row.hidden = true;
        row.innerHTML = '<span data-ib-disc-label>Buy 2, Get 1 Free</span><span data-ib-disc></span>';
        sub.parentNode.parentNode.insertBefore(row, sub.parentNode.nextSibling);
      }
      var foot = $('[data-ib-foot]', this.el);
      var co = $('[data-ib-checkout]', this.el);
      if (co && co.firstElementChild && !$('.ib-lock', co)) {
        co.firstElementChild.outerHTML = '<span class="ib-lock">' + ICON.lock + '<span>Secure checkout</span></span>';
      }
      this.payIcons();
      if (foot && !$('.ib-assure', foot)) {
        var ratingSrc = $('.ib-rating');
        var score = ratingSrc && (ratingSrc.textContent.match(/\d\.\d/) || [])[0];
        var assure = document.createElement('div');
        assure.className = 'ib-assure';
        assure.innerHTML = (score ? '<b>★★★★★</b><span>' + esc(score) + '/5</span><span>·</span>' : '') + '<span>60-day money-back guarantee</span>';
        foot.appendChild(assure);
      }
      window.setInterval(function () { self.tick(); }, 1000);

      $$('[data-ib-cart-close]', this.el).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });

      this.el.addEventListener('click', function (e) {
        var paidBtn = e.target.closest('[data-ib-paid]');
        if (paidBtn) {
          var paid = Math.max(0, parseInt(paidBtn.getAttribute('data-ib-paid'), 10));
          self.busy(paidBtn, setOil(totalFor(paid)));
          return;
        }
        var qtyBtn = e.target.closest('[data-ib-qty]');
        if (qtyBtn) {
          var line = qtyBtn.closest('[data-key]');
          var q = Math.max(0, parseInt(qtyBtn.getAttribute('data-ib-qty'), 10));
          self.busy(qtyBtn, postJSON('cart/change.js', { id: line.getAttribute('data-key'), quantity: q }));
          return;
        }
        var up = e.target.closest('[data-ib-upgrade]');
        if (up) {
          var have = self.state ? self.state.qty : 0;
          self.busy(up, setOil(totalFor(Math.max(2, paidFor(have)))));
        }
      });
      this.refresh();
    }
  };

  /* ---------- UGC videos ---------- */
  function initUgc() {
    $$('[data-ib-ugc]').forEach(function (card) {
      var btn = $('[data-ib-ugc-play]', card);
      var video = $('video', card);
      if (!btn || !video) return;
      btn.addEventListener('click', function () {
        video.muted = false;
        video.controls = true;
        video.play();
        card.classList.add('is-playing');
      });
    });
  }

  /* ---------- Review wall ---------- */
  function initReviews() {
    var wall = $('[data-ib-wall]');
    if (!wall) return;
    var reviews = $$('[data-ib-review]', wall);
    var moreBtn = $('[data-ib-more-btn]');
    var filters = $$('[data-ib-filter]');

    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        var key = f.getAttribute('data-ib-filter');
        filters.forEach(function (x) { x.classList.toggle('is-active', x === f); });
        reviews.forEach(function (r) {
          var tags = (r.getAttribute('data-tags') || '').split(' ');
          r.hidden = !(key === 'all' || tags.indexOf(key) !== -1);
        });
        if (moreBtn) moreBtn.hidden = true;
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var hidden = reviews.filter(function (r) { return r.hasAttribute('data-ib-more') && r.hidden; });
        hidden.slice(0, 8).forEach(function (r) { r.hidden = false; });
        if (hidden.length <= 8) moreBtn.hidden = true;
      });
    }
  }

  function init() {
    initMenu();
    initAnnounce();
    initHeader();
    initClinic();
    initGallery();
    initCarousels();
    initBuyBox();
    initUrgency();
    Drawer.init();
    initUgc();
    initReviews();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();